import { HttpClient } from '@/api';

export const useHttp = () => {
  return {
    get: async (url, query = null, headers = null, options = {}) => HttpClient.get(url, query, headers, options),
    post: async (url, body = null, headers = null, options = {}) => HttpClient.post(url, body, headers, options),
    put: async (url, body, headers = null) => HttpClient.put(url, body, headers),
    delete: async (url, headers = null) => HttpClient.delete(url, headers),
  };
};
